import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./inventry.scss";
import { fetchVehicle } from "../../store/slices/Vehicle/thunk";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  TextField,
  IconButton,
  Chip,
  Button,
} from "@mui/material";
import { MdDelete } from "react-icons/md";
import AddIcon from '@mui/icons-material/Add';
import { IoSearchOutline } from "react-icons/io5";
import EditIcon from "@mui/icons-material/Edit";
import { deleteInventory, fetchInventory } from "../../store/slices/thunk";
import { useNavigate } from "react-router-dom";
import ConfirmDialog from "../../components/deleteModal";
import Loader from "../../components/loader";
import { useClientFilter } from "../../Hooks/useClientFilter";
import FilterPopover from "../../components/FilterPopover/FilterPopover";
const PartInventoryList = () => {
  const [search, setSearch] = useState("");
  const dispatch: any = useDispatch();
  const [getAllInventory, setAllInventory] = useState([]);
  const [page, setPage] = useState(1);
  const navigate = useNavigate();
  const [totalCount, setTotalCount] = useState(0);
  const DEBOUNCE_DELAY = 500; // milliseconds
  const ITEMS_PER_PAGE = 10;
  const pageCount = Math.ceil(totalCount / ITEMS_PER_PAGE);
  const [openDialog, setOpenDialog] = useState(false);
  const [deleteId, setDeleteId] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const { filteredData, filters, setFilter, clearFilter } = useClientFilter(getAllInventory);
  useEffect(() => {

    const handler = setTimeout(async () => {
      setIsLoading(true); // Start loader
      try {
        const response = await dispatch(fetchInventory(page, ITEMS_PER_PAGE, search));
        if (response && response?.data && response?.data?.data && response?.data?.data?.length && response?.isSuccess) {
          setAllInventory(response?.data?.data);
          setTotalCount(response?.data?.totalCount);
        } else {
          setAllInventory([]);
          setTotalCount(0);
        }
      } catch (error) {
        console.log(getAllInventory);
        setAllInventory([]);
        setTotalCount(0);
      } finally {
        setIsLoading(false); // Stop loader
      }
    }, DEBOUNCE_DELAY);
    return () => {
      clearTimeout(handler);
    }
  }
    , [search, page, dispatch]);
  const gotoEdit = (id: string) => {
    navigate(`/edit-partinventory/${id}`);
  };

  const handleDelete = async (id: string) => {
    const response = await dispatch(deleteInventory(id));
    if (response && response.isSuccess) {
      const updatedInventory = getAllInventory.filter(
        (item: any) => item._id !== id
      );
      setAllInventory(updatedInventory);
    }
  }
  const handleDeleteClick = (id: string) => {
    setDeleteId(id);
    setOpenDialog(true);
  };
  const navigateToInvemtoryAdd = () => {
    navigate("/add-partinventory");
  };
  const confirmDelete = async () => {
    if (deleteId) {
      await handleDelete(deleteId);
    }
    setOpenDialog(false);
    setDeleteId(null);
  };



  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <div className="inventory-list" style={{ flexShrink: 0 }}>
          <div className="d-flex flex-column">
            <h2 style={{ color: "#0f172a", fontWeight: "700", fontSize: "24px", margin: "0", fontFamily: "sans-serif" }}>
              Inventory Management (Parts)
            </h2>
            <p style={{ color: "#64748b", fontSize: "14px", margin: "4px 0 0 0", fontWeight: "400" }}>
              Manage all parts and inventory items
            </p>
          </div>
        <p>
          {" "}
                   <button className="px-2 py-2" onClick={navigateToInvemtoryAdd} style={{background:" #3b82f6", color:"#fff", borderRadius:"10px", border:"none", height:"auto", width:"auto"}}> <AddIcon />Add New Item</button>        </p>
      </div>
      <Paper sx={{ padding: 2, flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
        <div style={{ flex: 1, overflow: "hidden", display: "flex", flexDirection: "column" }}>
        <TableContainer sx={{ overflowY: "auto", flex: 1, minHeight: 0 }}>
               <div className="search-box align-items-baseline justify-content-start" style={{marginBottom:"25px", flexShrink: 0}}>
                <div className="search-wrapper">
                  <IoSearchOutline className="search-icon" />
                  <input
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Search Parts Inventory Here"
                  />
                </div>
          </div>
          <Table className="table">
            <TableHead className="th">
              <TableRow className="table-h-row">
  <TableCell className="table-cell" style={{ color: "#374151", background: "#f9fafb", fontWeight: 500, fontSize: "18px" }}>
    S.No
  </TableCell>
  <TableCell className="table-cell" style={{ color: "#374151", background: "#f9fafb", fontWeight: 500, fontSize: "18px" }}>
    Name
    <FilterPopover column="name" filterType="text" currentValue={filters.name || ""} onFilterChange={setFilter} onClear={clearFilter} />
  </TableCell>
  <TableCell className="table-cell" style={{ color: "#374151", background: "#f9fafb", fontWeight: 500, fontSize: "18px" }}>
    Description
    <FilterPopover column="description" filterType="text" currentValue={filters.description || ""} onFilterChange={setFilter} onClear={clearFilter} />
  </TableCell>
  <TableCell className="table-cell" style={{ color: "#374151", background: "#f9fafb", fontWeight: 500, fontSize: "18px" }}>
    Stock
    <FilterPopover column="stock" filterType="text" currentValue={filters.stock || ""} onFilterChange={setFilter} onClear={clearFilter} />
  </TableCell>
  <TableCell className="table-cell" style={{ color: "#374151", background: "#f9fafb", fontWeight: 500, fontSize: "18px" }}>
    Status
    <FilterPopover column="status" filterType="text" currentValue={filters.status || ""} onFilterChange={setFilter} onClear={clearFilter} />
  </TableCell>
  <TableCell className="table-cell" style={{ color: "#374151", background: "#f9fafb", fontWeight: 500, fontSize: "18px" }}>
    Action
  </TableCell>
</TableRow>

            </TableHead>
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  <Loader />
                </TableCell>
              </TableRow>
            ) : (
              <TableBody className="tb">
                {filteredData.map((item: any, index) => (
                  <TableRow className="t-row" key={index}>
                    <TableCell className="table-cell">{index + 1}</TableCell>
                    <TableCell className="table-cell">
                      {item.name || "--"}
                    </TableCell>
                    <TableCell className="table-cell">
                      {item.description || "--"}
                    </TableCell>
                    <TableCell className="table-cell">
                      {item.stock || "--"}
                    </TableCell>
                    <TableCell className="table-cell">
                      <Chip
                        label={item.status || "--"}
                        style={{background:" #d1fae5", color:"#065f46"}}
                        size="small"
                      />
                    </TableCell>
                    <TableCell className="table-cell">
                      <IconButton className="">
                        <EditIcon
                          onClick={() => gotoEdit(item._id)}
                          style={{ color: "primary" }}
                          className="icons"
                        />
                      </IconButton>
                      <IconButton className="icon-btn-red">
                        <MdDelete
                          onClick={() => handleDeleteClick(item._id)}
                          style={{ color: "red" }}
                          className="icons"
                        />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
                <ConfirmDialog
                  open={openDialog}
                  onClose={() => setOpenDialog(false)}
                  onConfirm={confirmDelete}
                />

                {filteredData.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      No Inventory Found.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            )}
          </Table>
        </TableContainer>
        </div>
        <nav style={{ flexShrink: 0 }}>
          <ul className="pagination justify-content-center">
            <li
              className={`page-item ${page === 1 && "disabled"
                }`}
            >
              <button
                className="page-link"
                onClick={() =>
                  setPage((p) => Math.max(p - 1, 1))
                }
              >
                Previous
              </button>
            </li>

            {Array.from(
              { length: Math.min(5, pageCount) },
              (_, i) => (
                <li
                  key={i + 1}
                  className={`page-item ${page === i + 1 && "active"
                    }`}
                >
                  <button
                    className="page-link"
                    onClick={() => setPage(i + 1)}
                  >
                    {i + 1}
                  </button>
                </li>
              )
            )}

            {pageCount > 5 && (
              <>
                <li className="page-item disabled">
                  <span className="page-link">...</span>
                </li>
                <li className="page-item">
                  <button
                    className="page-link"
                    onClick={() => setPage(pageCount)}
                  >
                    {pageCount}
                  </button>
                </li>
              </>
            )}

            <li
              className={`page-item ${page === pageCount && "disabled"
                }`}
            >
              <button
                className="page-link"
                onClick={() =>
                  setPage((p) => Math.min(p + 1, pageCount))
                }
              >
                Next
              </button>
            </li>
          </ul>
        </nav>
      </Paper>
    </div>
  );
};

export default PartInventoryList;

